var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"cart-detail"},[_c('section',{staticClass:"cart-detail-item"},[_c('h3',{staticClass:"text-left"},[_c('em',[_vm._v(_vm._s(_vm.paymentDetailName))])]),_c('h4',{staticClass:"text-right"},[_c('em',[_vm._v(_vm._s(_vm._f("currency")(_vm.paymentDetailValue)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }